import { isMobile } from "@rio-cloud/rio-uikit/utils/deviceUtils";

const fixedColumnsValues = [
  "criticidade",
  "veiculo",
  "chassi",
  "odometro",
  "horimetro",
  "fixedTempo",
];
const fixedColumnsMobileValues = ["veiculo"];

const scrollableColumnsValues = [
  "chamado",
  "triagem",
  "deslocamento",
  "remocao",
  "diagnose2nivel",
  "diagnose3nivel",
  "diagnose4nivel",
  "analiseGarantia",
  "okCliente",
  "pecas",
  "pecasTransito",
  "aguardandoReparo",
  "reparo",
  "liberacao",
];
const scrollableColumnsMobileValues = [
  "criticidade",
  "chassi",
  "odometro",
  "horimetro",
  "tempo",
  "chamado",
  "triagem",
  "deslocamento",
  "remocao",
  "diagnose2nivel",
  "diagnose3nivel",
  "diagnose4nivel",
  "analiseGarantia",
  "okCliente",
  "pecas",
  "pecasTransito",
  "aguardandoReparo",
  "reparo",
  "liberacao",
];

const allColumns = [
  {
    value: "criticidade",
    labelId: "intl-msg:kanban.tableConfigs.criticality",
    details: { width: 120, defaultWidth: 120, maxWidth: 350 },
  },
  {
    value: "veiculo",
    labelId: "intl-msg:kanban.tableConfigs.vehicle",
    details: { width: 100, defaultWidth: 100, maxWidth: 350 },
  },
  {
    value: "chassi",
    labelId: "intl-msg:kanban.tableConfigs.chassis",
    details: { width: 150, defaultWidth: 150, maxWidth: 350 },
  },
  {
    value: "odometro",
    labelId: "intl-msg:kanban.tableConfigs.odometer",
    details: { width: 120, defaultWidth: 120, maxWidth: 350 },
  },
  {
    value: "horimetro",
    labelId: "intl-msg:kanban.tableConfigs.hourmeter",
    details: { width: 120, defaultWidth: 120, maxWidth: 350 },
  },
  {
    value: "fixedTempo",
    labelId: "intl-msg:kanban.tableConfigs.totalElapsedTime",
    details: { width: 150, defaultWidth: 250, maxWidth: 250 },
  },
  {
    value: "chamado",
    labelId: "intl-msg:kanban.tableConfigs.call",
    details: { width: 120, defaultWidth: 120, maxWidth: 150 },
  },
  {
    value: "triagem",
    labelId: "intl-msg:kanban.tableConfigs.screening",
    details: { width: 160, defaultWidth: 160, maxWidth: 160 },
  },
  {
    value: "deslocamento",
    labelId: "intl-msg:kanban.tableConfigs.displacement",
    details: { width: 100, defaultWidth: 100, maxWidth: 130 },
  },
  {
    value: "remocao",
    labelId: "intl-msg:kanban.tableConfigs.removal",
    details: { width: 100, defaultWidth: 100, maxWidth: 150 },
  },
  {
    value: "diagnose2nivel",
    labelId: "intl-msg:kanban.tableConfigs.secondDiagnosis",
    details: { width: 100, defaultWidth: 100, maxWidth: 100 },
  },
  {
    value: "diagnose3nivel",
    labelId: "intl-msg:kanban.tableConfigs.thirdDiagnosis",
    details: { width: 100, defaultWidth: 100, maxWidth: 100 },
  },
  {
    value: "diagnose4nivel",
    labelId: "intl-msg:kanban.tableConfigs.fourthDiagnosis",
    details: { width: 100, defaultWidth: 100, maxWidth: 120 },
  },
  {
    value: "analiseGarantia",
    labelId: "intl-msg:kanban.tableConfigs.warrantyAnalysis",
    details: { width: 100, defaultWidth: 100, maxWidth: 160 },
  },
  {
    value: "okCliente",
    labelId: "intl-msg:kanban.tableConfigs.customerOk",
    details: { width: 100, defaultWidth: 100, maxWidth: 200 },
  },
  {
    value: "pecas",
    labelId: "intl-msg:kanban.tableConfigs.parts",
    details: { width: 100, defaultWidth: 100, maxWidth: 200 },
  },
  {
    value: "pecasTransito",
    labelId: "intl-msg:kanban.tableConfigs.partsInTransit",
    details: { width: 100, defaultWidth: 100, maxWidth: 200 },
  },
  {
    value: "aguardandoReparo",
    labelId: "intl-msg:kanban.tableConfigs.awaitingRepair",
    details: { width: 100, defaultWidth: 100, maxWidth: 200 },
  },
  {
    value: "reparo",
    labelId: "intl-msg:kanban.tableConfigs.repair",
    details: { width: 100, defaultWidth: 100, maxWidth: 200 },
  },
  {
    value: "liberacao",
    labelId: "intl-msg:kanban.tableConfigs.release",
    details: { width: 100, defaultWidth: 100, maxWidth: 200 },
  },
];

export const fixedColumns = allColumns.filter((column) => {
  if (isMobile()) return fixedColumnsMobileValues.includes(column.value);
  return fixedColumnsValues.includes(column.value);
});

export const scrollableColumns = allColumns.filter((column) => {
  if (isMobile()) return scrollableColumnsMobileValues.includes(column.value);
  return scrollableColumnsValues.includes(column.value);
});
